export default "__VITE_ASSET__f498f912__"